import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const StarFilled = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.37839 2.46724C7.69374 1.82522 8.61745 1.85036 8.8974 2.50859L10.3177 5.84797H13.1139C13.8592 5.84797 14.2316 6.74973 13.7036 7.27566L11.2867 9.68287L11.9495 12.9754C12.096 13.7031 11.2917 14.2463 10.6713 13.8386L8.13883 12.174L5.52506 13.8639C4.92064 14.2547 4.13785 13.7495 4.24505 13.0377L4.74802 9.69838L2.29876 7.27796C1.76754 6.753 2.13928 5.84797 2.88613 5.84797H5.71786L7.37839 2.46724Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default StarFilled;
